var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "d-flex" }, [
      _c("div", { staticClass: "field col-6 col-md-4" }, [
        _vm._v("Nombre documento:")
      ]),
      _c("div", { staticClass: "values col-6" }, [
        _vm._v(_vm._s(_vm.data.nombre))
      ])
    ]),
    _c("div", { staticClass: "d-flex" }, [
      _c("div", { staticClass: "field col-6 col-md-4" }, [_vm._v("Número:")]),
      _c("div", { staticClass: "values col-6" }, [
        _vm._v(_vm._s(_vm.data.numero))
      ])
    ]),
    _c("div", { staticClass: "d-flex" }, [
      _c("div", { staticClass: "field col-6 col-md-4" }, [
        _vm._v("Hora y Fecha inicio del proceso:")
      ]),
      _c("div", { staticClass: "values col-6" }, [
        _vm._v(_vm._s(_vm.data.fecha_inicio_proceso.replace(" ", " a las ")))
      ])
    ]),
    _c("div", { staticClass: "d-flex" }, [
      _c("div", { staticClass: "field col-6 col-md-4" }, [
        _vm._v("Hora y Fecha creación:")
      ]),
      _c("div", { staticClass: "values col-6" }, [
        _vm._v(_vm._s(_vm.data.fecha_creacion.replace(" ", " a las ")))
      ])
    ]),
    _c("div", { staticClass: "d-flex" }, [
      _c("div", { staticClass: "field col-6 col-md-4" }, [
        _vm._v("Hora y Fecha actualización:")
      ]),
      _c("div", { staticClass: "values col-6" }, [
        _vm._v(_vm._s(_vm.data.fecha_actualizacion.replace(" ", " a las ")))
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }